export const LOGIN_FIELDS_ERRORS = {
    email: ['error.email_didnt_registered'],
    password: ['error.password_not_valid'],
}
